const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateFullName(value: string): string | null {
  if (value.trim().length === 0) {
    return 'Full name is required';
  }
  if (value.trim() !== value) {
    return 'Full name cannot start or end with spaces';
  }
  if (value.trim().endsWith('.')) {
    return 'Full name cannot end with a period';
  }
  return null;
}

export function validateEmail(value: string): string | null {
  if (!value.trim()) {
    return 'Email is required';
  }
  if (!EMAIL_PATTERN.test(value.trim())) {
    return 'Enter a valid email';
  }
  return null;
}

export function validatePassword(value: string, minLength: number): string | null {
  if (!value) {
    return 'Password is required';
  }
  if (value.length < minLength) {
    return `Password must be at least ${minLength} characters`;
  }
  return null;
}
